import apiUrl from "../../../../../utils/settings";

export const createDPOrderUrl = () => {
  return apiUrl + '/user-orders/create-order';
};
export const getSkuCategoryDetailUrl = () => {
  return apiUrl + '/product-sku/get-all-sku-value';
};
export const getCategoryProductUrl = () => {
  return apiUrl + '/product-sku/get-product-sku-list';
};
export const getpricingGeographyUrl = () => {
  return apiUrl + '/manufacturer-pricing-geography/pricing-geography';
};
export const comparePriceBtwPricingGeoUrl = () => {
  return ( apiUrl + '/product-prices/compare-product-prices-between-two-pricing-geography' );
};
export const getOrderSummaryUrl = () => {
  return apiUrl + '/user-orders/calculate-order-amount';
};
export const modifyOrderUrl = () => {
  return apiUrl + '/user-orders/modify-order';
};
export const deleteDPUrl = () => {
  return apiUrl + '/user-orders/delete-order';
};



